import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { Practitioner } from 'src/models';
export type GetPractitionerListResponse = {
  practitioners: Practitioner[];
};

export type GetPractitionerListParams = {
  is_shown?: boolean;
};

export const useGetPractitionerList = (params?: GetPractitionerListParams) => {
  return useQuery({
    queryKey: ['practitionerList', params],
    queryFn: () =>
      api
        .get<GetPractitionerListResponse>(`/practitioners`, {
          params,
        })
        .then(({ data }) => data),
    refetchOnWindowFocus: false,
  });
};
